import SupportTheme from '@/pages/SupportChat/SupportTheme';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { MainLayout } from '../Layouts/MainLayout';
import { checkRegistrationAvailable } from '../common/helpers';
import { useTypedSelector } from '../hooks/useTypedSelector';
import { Home } from '../pages/Home';
import { Login } from '../pages/Login';
import { Orders } from '../pages/Orders';
import { Registration } from '../pages/Registration';
import SupportChat from '../pages/SupportChat/SupportChat';
import { pages } from './Routes.constants';
import { PagesTypes } from './Routes.interfaces';

export const AppRoutes = () => {
  const { accessToken } = useTypedSelector((state) => state.common);
  const { userInfo } = useTypedSelector((state) => state.registration);

  return (
    <BrowserRouter>
      {accessToken ? (
        <MainLayout>
          <Routes>
            <Route path={pages[PagesTypes.PROFILE].path}>
              <Route index element={<Home />} />
            </Route>

            {checkRegistrationAvailable(userInfo) && (
              <Route path={pages[PagesTypes.DOC].path}>
                <Route index element={<Registration />} />
              </Route>
            )}

            {/* {IS_ASTERI_LK && ( */}
            <Route path={pages[PagesTypes.ORDERS].path}>
              <Route index element={<Orders />} />
            </Route>
            {/* )} */}

            <Route path={pages[PagesTypes.SUPPORT_CHAT].path}>
              <Route index element={<SupportTheme />} />
              <Route path=":id" element={<SupportChat />} />
            </Route>

            <Route
              path="*"
              element={<Navigate to={pages[PagesTypes.PROFILE].path} />}
            />
          </Routes>
        </MainLayout>
      ) : (
        <Routes>
          <Route path={pages[PagesTypes.AUTH].path}>
            <Route index element={<Login />} />
          </Route>

          <Route
            path="*"
            element={<Navigate to={pages[PagesTypes.AUTH].path} />}
          />
        </Routes>
      )}
    </BrowserRouter>
  );
};
